import {Point} from '@app/modules/svg/model/Point';
import {PointedView} from '@app/modules/svg/element/shape/pointed/PointedView';
import {LineView} from '@app/modules/svg/element/shape/pointed/LineView';
import {SVGEvent} from '@app/modules/svg/dataSource/constant/SVGEvent';
import {ElementType} from '@app/modules/svg/dataSource/constant/ElementType';
import {DrawTwoPoint} from '@app/modules/svg/service/tool/draw/element/DrawTwoPoint';

export class DrawLine extends DrawTwoPoint {
  protected createDrawableElement(position: Point): PointedView {
    const element: LineView = new LineView(this.drawTool.container, {overEvent: true, globalStyle: true}, position, position);
    element.__fixRect__();
    return element;
  }

  public override start(call: boolean = true): void {
    super.start(call);

    if (call) {
      this.drawTool.container.__call__(SVGEvent.LINE_TOOL_ON);
    }
  }
  public override stop(call: boolean = true): void {
    super.stop(call);

    if (call) {
      this.drawTool.container.__call__(SVGEvent.LINE_TOOL_OFF);
    }
  }

  public _new(): DrawLine {
    return new DrawLine(this.drawTool);
  }
  public get type(): ElementType {
    return ElementType.LINE;
  }
}
